import { IconDashboard } from '@tabler/icons-react';
import { IconMail } from '@tabler/icons-react';
import { IconBook } from '@tabler/icons-react';
import { IconBooks } from '@tabler/icons-react';
import { IconHeartRateMonitor } from '@tabler/icons-react';
import { IconSettings2 } from '@tabler/icons-react';

import { getDeployment } from 'utils/deployment';

const icons = {
    IconDashboard,
    IconMail,
    IconBook,
    IconBooks,
    IconHeartRateMonitor,
    IconSettings2
};

const deployment = getDeployment();

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    icon: icons.IconDashboard,
    type: 'group',
    breadcrumbs: false,
    url: '/dashboard',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:learners/1`
    },
    tags: ['dashboard', 'home', 'overview', 'summary', 'insights', 'main page']
};

const learners = {
    id: 'learners',
    title: 'Learners',
    type: 'single',
    url: '/learners',
    subMenus: [
        {
            id: 'learner-results',
            title: 'Learner Results',
            urlParams: 'learner-results',
            tags: [
                'learner results',
                'learner result',
                'results',
                'result',
                'learning results',
                'quiz results',
                'learner progress',
                'learning result',
                'reading result',
                'writing result',
                'numeracy result',
                'oral communication result',
                'capability graph',
                'capability score',
                'access score'
            ]
        },
        {
            id: 'archived-results',
            title: 'Archived Results',
            urlParams: 'archived-results',
            tags: [
                'archived results',
                'archived learner results',
                'archived result',
                'archived learner result',
                'archive',
                'archive learner',
                'archives',
                'archive learners',
                'archived data',
                'archived learners data',
                'data archive',
                'learners data archive',
                'view archived results',
                'view learners archived results'
            ]
        },
        {
            id: 'recently-deleted',
            title: 'Recently Deleted',
            urlParams: 'recently-deleted',
            tags: ['recently deleted', 'recently learner deleted', 'learner deleted', 'deleted learner']
        }
    ],
    tags: ['learners', 'students', 'users', 'participants', 'people', 'profiles']
};

const invite = {
    id: 'invite',
    title: 'Invite',
    icon: icons.IconMail,
    type: 'group',
    breadcrumbs: false,
    url: '/invite',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:learners/1`,
        action: 'CanInvite'
    },
    tags: ['invite', 'email', 'send invite', 'add learner', 'registration', 'enrol', 'onboard']
};

const myCourses = {
    id: 'courses',
    title: 'Courses',
    icon: icons.IconBook,
    type: 'group',
    breadcrumbs: false,
    url: '/courses',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:courses/1`
    },
    tags: ['courses', 'training', 'modules', 'classes', 'learning', 'education', 'lessons']
};

const resources = {
    id: 'resources',
    title: 'Resources',
    icon: icons.IconBooks,
    type: 'group',
    breadcrumbs: false,
    url: '/resources',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:llnresources/1`,
        disableInTrial: true
    },
    tags: ['resources', 'materials', 'documents', 'library', 'files', 'references', 'guides']
};

const analytics = {
    id: 'analytics',
    title: 'Analytics',
    icon: icons.IconHeartRateMonitor,
    type: 'group',
    breadcrumbs: false,
    url: '/analytics',
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:analytics/1`,
        disableInTrial: true
    },
    tags: ['analytics', 'reports', 'statistics', 'data', 'insights', 'performance', 'metrics']
};

const systemSettings = {
    id: 'system-settings',
    title: 'System Settings',
    icon: icons.IconSettings2,
    type: 'group',
    url: '/system-settings',
    breadcrumbs: false,
    permissions: {
        resource: `arn:tlrg:lln-robot::${deployment}:settings/1`,
        disableInTrial: true
    },
    tags: ['settings', 'configuration', 'preferences', 'system', 'admin', 'control panel'],
    subMenus: [
        {
            id: 'organisational-settings',
            title: 'Organisational Settings',
            urlParams: 'organisational-settings',
            tags: [
                'organisation',
                'profile',
                'org profile',
                'business details',
                'company info',
                'contact details',
                'logo',
                'company logo',
                'phone',
                'website',
                'organisational settings'
            ]
        },
        {
            id: 'subscriptions',
            title: 'Subscriptions',
            urlParams: 'subscriptions',
            tags: [
                'subscription',
                'subscriptions',
                'billing',
                'billing details',
                'billing info',
                'payment',
                'payments',
                'payment method',
                'payment settings',
                'payment history',
                'plan',
                'plans',
                'account plan',
                'expiry',
                'expiration',
                'subscription settings'
            ]
        },
        {
            id: 'notifications',
            title: 'Notifications',
            urlParams: 'notifications',
            tags: [
                'notification',
                'notifications',
                'alerts',
                'email notifications',
                'system notifications',
                'push notifications',
                'reminders',
                'user notifications',
                'admin notifications',
                'notification settings'
            ]
        },
        {
            id: 'manage-users',
            title: 'Manage Users',
            urlParams: 'manage-users',
            tags: [
                'users',
                'user',
                'manage users',
                'user management',
                'accounts',
                'account management',
                'admins',
                'administrators',
                'roles',
                'permissions',
                'access',
                'access control',
                'user access',
                'user roles',
                'active users',
                'inactive users',
                'user details',
                'manage users settings'
            ]
        },
        {
            id: 'learner-form',
            title: 'Learner Form',
            urlParams: 'learner-form',
            tags: ['learner form', 'learner information', 'learner details', 'learner form settings']
        },
        {
            id: 'email-templates',
            title: 'Email Templates',
            urlParams: 'email-templates',
            tags: [
                'email',
                'emails',
                'email templates',
                'email template',
                'template',
                'templates',
                'manage email templates',
                'edit email template',
                'email template settings'
            ]
        },
        {
            id: 'integrations',
            title: 'Integrations',
            urlParams: 'integrations',
            tags: [
                'integration',
                'integrations',
                'api',
                'api integration',
                'api settings',
                'external api',
                'external service',
                'external services',
                'connected apps',
                'automation',
                'automations',
                'system integration',
                'axcelerate',
                'vettrak',
                'wisenet',
                'integration settings'
            ]
        },
        {
            id: 'quiz-settings',
            title: 'Quiz Settings',
            urlParams: 'quiz-settings',
            tags: ['quiz', 'quizzes', 'default quiz', 'quiz settings']
        },
        {
            id: 'direct-links',
            title: 'Direct Links',
            urlParams: 'direct-links',
            tags: [
                'direct links',
                'direct link',
                'links',
                'quick links',
                'link management',
                'manage links',
                'external links',
                'acsf3 short couse link',
                'acsf3 link',
                'acsf4 link',
                'direct link settings'
            ]
        }
    ]
};

const accountSettings = {
    id: 'account-settings',
    title: 'Account Settings',
    type: 'single',
    url: '/my-profile',
    tags: [
        'account',
        'settings',
        'profile',
        'my account',
        'user settings',
        'personal info',
        'preferences',
        'profile settings',
        'account details',
        'edit profile',
        'change password',
        'update email'
    ]
};

export default [dashboard, learners, invite, myCourses, resources, analytics, systemSettings, accountSettings];
